import React from 'react';

export const Preview = ({url}) => {
  return url
    ? <iframe
      title="pdf-preview"
      src={`${url}#pagemode=none`}
      width="100%" height="100%"/>
    : null;
};
